<div class="staff-operations-page">
  <div class="page-header">
    <div>
      <p class="eyebrow">People Control</p>
      <h2>Staff Operations</h2>
      <p class="subtitle">Monitor request flow, communication load, inactive staff, and profile gaps from one operations board.</p>
    </div>
    <button mat-stroked-button (click)="loadOperations()">Refresh</button>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <section class="stats-grid">
    <article class="stat-card warning">
      <span>Pending Requests</span>
      <strong>{{ pendingRequests.length }}</strong>
      <small>Waiting for decision</small>
    </article>
    <article class="stat-card success">
      <span>Approved</span>
      <strong>{{ approvedRequests }}</strong>
      <small>Resolved positively</small>
    </article>
    <article class="stat-card danger">
      <span>Rejected</span>
      <strong>{{ rejectedRequests }}</strong>
      <small>Closed with rejection</small>
    </article>
    <article class="stat-card accent">
      <span>Inactive Staff</span>
      <strong>{{ inactiveStaff.length }}</strong>
      <small>Immediate workforce follow-up</small>
    </article>
  </section>

  <section class="content-grid">
    <article class="panel">
      <div class="panel-head">
        <h3>Approval Queue</h3>
        <span>Latest pending items</span>
      </div>
      <div class="queue-list" *ngIf="latestPendingRequests.length; else noPending">
        <div class="queue-item" *ngFor="let row of latestPendingRequests">
          <div>
            <strong>{{ row.title || row.requestType }}</strong>
            <p>{{ row.staffName || row.requestedByName || 'Staff request' }}</p>
          </div>
          <div class="queue-meta">
            <span>{{ row.requestType }}</span>
            <small>{{ row.requestedAt | date:'mediumDate' }}</small>
          </div>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Communication Load</h3>
        <span>Inbox and sent traffic</span>
      </div>
      <div class="metric-list">
        <div class="metric-row" *ngFor="let row of responseLoad">
          <strong>{{ row.label }}</strong>
          <span>{{ row.value }}</span>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Profile Gaps</h3>
        <span>Missing core details</span>
      </div>
      <div class="people-list" *ngIf="profileGaps.length; else noGaps">
        <div class="person-row" *ngFor="let row of profileGaps">
          <strong>{{ row.fullName }}</strong>
          <small>{{ row.department || 'No department' }} · {{ row.position || 'No position' }}</small>
        </div>
      </div>
    </article>

    <article class="panel compact">
      <div class="panel-head">
        <h3>Inactive Staff</h3>
        <span>Needs review</span>
      </div>
      <div class="people-list" *ngIf="inactiveStaff.length; else noInactive">
        <div class="person-row" *ngFor="let row of inactiveStaff">
          <strong>{{ row.fullName }}</strong>
          <small>{{ row.department || 'No department' }} · {{ row.position || 'No position' }}</small>
        </div>
      </div>
    </article>
  </section>
</div>

<ng-template #noPending>
  <p class="muted">No pending staff requests right now.</p>
</ng-template>

<ng-template #noGaps>
  <p class="muted">No profile gaps detected in the current slice.</p>
</ng-template>

<ng-template #noInactive>
  <p class="muted">No inactive staff found.</p>
</ng-template>
